import React from 'react';
import { get } from 'lodash';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { SAVED_DASHBOARD_PATHS } from '@utils/constants';
import { getBaseUrlByProduct } from '../utils';

export const StyledLink = styled(Link)`
  color: #0046ff;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface IDashboardType {
  name: string;
  id: number;
}
interface IProps {
  id: number;
  name: string;
  productName: string;
  dashboard: string;
  dashboardType: IDashboardType;
}

const NameLink = ({ id, name, productName = 'ei', dashboard, dashboardType }: IProps) => {
  if (dashboard === 'pulse5') {
    const urlPrefix = getBaseUrlByProduct(productName);
    const nameInUrl = get(SAVED_DASHBOARD_PATHS, [dashboardType.name], '');
    const url = nameInUrl ? `${urlPrefix}/dashboard/${nameInUrl}/${id}` : '';
    if (url) {
      return <StyledLink to={`${url}`}>{name}</StyledLink>;
    }
    return <>{name}</>;
  }
  return (
    <StyledLink to={window.__POWERED_BY_QIANKUN__ ? `/app/pulse/reports/${id}` : `/reports/${id}`}>
      {name}
    </StyledLink>
  );
};

export default NameLink;
